import { Fragment } from 'react'
import Alert from '../Alert'
import { router, usePage } from '@inertiajs/react'
import Button from '../Button'

export default function AccountAlerts() {
  const { user } = usePage().props?.auth
  const { alerts } = user || {}

  const aboutToExpire = user.expiration_countdown <= 7

  const onConfirm = () => {
    router.post(route('settings.confirm'))
  }

  return (
    <Fragment>
      {alerts.account.is_expiring && (
        <Alert
          type={aboutToExpire ? 'danger' : 'notice'}
          heading={
            aboutToExpire ? 'Your PRO Website is about to expire' : "Your PRO Website hasn't been verified recently and may be outdated"
          }
          subtext={
            <div className="space-y-2 font-normal">
              <p>
                To continue to be listed with LSNPros.com, we periodically request that you review the information provided to confirm that
                it is both accurate and up-to-date. Please review your account, perform any necessary updates and click the{' '}
                <span className="font-bold">Confirm My Information</span> button to confirm that your information is up-to-date.
              </p>
              <p>
                <span className="font-bold">
                  If no further action is taken, your Website will expire on {user.expires_at} and no longer be listed with LSNPros.com.
                </span>
              </p>
            </div>
          }
        >
          <Alert.Actions>
            <Button
              theme="solid"
              colors={aboutToExpire ? 'bg-red-600 hover:bg-red-700 focus:ring-red-600' : 'bg-green-800 hover:bg-green-900'}
              onClick={() => onConfirm()}
            >
              Confirm My Information
            </Button>
          </Alert.Actions>
        </Alert>
      )}

      {user.visible === '' && (
        <Alert
          type="warning"
          heading="Your PRO-Website is not currently viewable to LSNPros Members."
          subtext={
            <div className="space-y-2">
              To make your website viewable to all LSNPros members internally, the general public or both internally and to the general
              public, you must complete your profile and publish your website.
            </div>
          }
        >
          {!window.location.pathname.startsWith('/account/settings') && (
            <Alert.Actions>
              <Button theme="solid" onClick={() => router.visit(route('my-website.index'))}>
                Publish My PRO-Website
              </Button>
            </Alert.Actions>
          )}
        </Alert>
      )}
    </Fragment>
  )
}
